<button
  class="rounded-button-square flex flex-grow content-center justify-center gap-x-3 px-4 py-2 text-center"
  data-cy="square-button"
  [ngClass]="getDynamicClasses()"
  (click)="action?.($event)">
  @if (icon) {
    <img class="flex h-[20px] w-[20px] self-center" [alt]="alt" [src]="icon" />
  }
  <div
    class="max-w-[250px] truncate overflow-hidden text-sm whitespace-nowrap"
    [ngClass]="text.includes('selected') ? 'font-normal' : 'font-semibold'">
    {{ text }}
  </div>
</button>
